<div [ngStyle]="{ position: !mocked ? 'absolute' : 'unset' }">
  <div
    (click)="openCustomChatWindow()"
    (keydown)="openCustomChatWindow()"
    class="genesys-chat"
    [style.position]="mocked && 'unset'"
  >
    <div class="genesys-chat__relative">
      <div class="genesys-chat__content">
        <ion-icon class="verti-feedback-24"></ion-icon>
        <span>{{ 'GENESYS_CHAT.BUTTON.TITLE' | translate }}</span>
      </div>
    </div>
  </div>
</div>

<div
  *ngIf="(isChatOpen && userName !== '') || isChatWindowOpen || (notAvailable && isChatOpen)"
  class="custom-genesys-chat-window"
  [ngClass]="{ 'chat-hidden': !toggleChat }"
>
  <div class="chat-header">
    <span class="chat-title">{{ 'GENESYS_CHAT.HEADER' | translate }}</span>
    <div class="chat-close-buttons">
      <span class="chat-close-button" (click)="minimize()" (keypress)="minimize()">__</span>
      <ion-icon class="verti-close-16 chat-close-button" (click)="closeCustomChatWindow()"></ion-icon>
    </div>
  </div>

  <div class="chat-messages-container">
    <div *ngIf="isLoading" class="chat-loading-overlay">
      <qb-ita-loading-spinner [showCard]="false" [flatCard]="false"></qb-ita-loading-spinner>
    </div>
    <div class="chat-messages" [ngClass]="{ 'chat-hidden': !toggleChat }">
      <div
        *ngFor="let message of displayedMessages"
        class="message-wrapper"
        [ngClass]="{
          'state-message-wrapper': message.type === 'state',
          'system-message-wrapper': message.type === 'system',
          'agent-message-wrapper': message.type === 'agent',
          'user-message-wrapper': message.type === 'user'
        }"
      >
        <div *ngIf="message.type === 'state'" class="chat-state-message">
          <span class="chat-state-message__text message-text">{{ message.text }}</span>
          <span *ngIf="message.time" class="chat-state-message__time message-meta">{{ message.time }}</span>
        </div>

        <ng-container *ngIf="message.type === 'agent'">
          <ion-icon class="verti-verti-cell icon-verti"></ion-icon>
          <div class="chat-message-bubble agent-message">
            <span *ngIf="message.type === 'agent'" class="chat-agent-message__agentName">{{
              message.agentName || 'Agente'
            }}</span>
            <span class="message-text">{{ message.text }}</span>
            <span class="message-meta">{{ message.time }}</span>
          </div>
        </ng-container>

        <ng-container *ngIf="message.type === 'system'">
          <ion-icon class="verti-verti-cell icon-verti"></ion-icon>
          <div class="chat-message-bubble agent-message">
            <span class="message-text" [innerHTML]="message.safeHtml ? message.safeHtml : message.text"></span>
            <span class="message-meta">{{ message.time }}</span>
          </div>
        </ng-container>

        <ng-container *ngIf="message.type === 'user'">
          <div class="chat-message-bubble user-message">
            <span class="message-text">{{ message.text }}</span>
            <span class="message-meta">{{ message.time }}</span>
          </div>
        </ng-container>
      </div>
      <ng-container *ngIf="isAgentTyping">
        <div class="typing-indicator">
          <div class="agent-typing-bubble typing-bubble">
            <div class="dot-flashing"></div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="chat-input-area" [ngClass]="{ 'chat-hidden': !toggleChat }">
    <qb-ita-input
      [(ngModel)]="messageInput"
      [placeholder]="'GENESYS_CHAT.MESSAGES.PLACEHOLDER' | translate"
      (keyup.enter)="sendUserMessage()"
      class="chat-input-field"
      [disabled]="!isChatStarted"
    ></qb-ita-input>
  </div>
</div>

<div
  *ngIf="isChatOpen && userName === '' && !isChatStarted && !notAvailable"
  class="custom-genesys-chat-window__widget"
  [ngClass]="{ 'chat-hidden__widget': !toggleChat }"
>
  <div class="chat-header">
    <span class="chat-title">{{ 'GENESYS_CHAT.HEADER' | translate }}</span>
    <div class="chat-close-buttons">
      <span class="chat-close-button" (click)="minimize()" (keypress)="minimize()">__</span>
      <ion-icon class="verti-close-16 chat-close-button" (click)="closeCustomChatWindow()"></ion-icon>
    </div>
  </div>
  <div class="widget-body">
    <div class="widget-body__inputGroup">
      <span class="widget-body__inputLabel">{{ 'GENESYS_CHAT.WIDGET.INPUT_LABEL' | translate }} </span>
      <qb-ita-input
        [(ngModel)]="inputName"
        [placeholder]="'GENESYS_CHAT.WIDGET.PLACEHOLDER' | translate"
        type="text"
        (keyup.enter)="submitName()"
      ></qb-ita-input>
    </div>
  </div>
  <div class="widget-body__buttons">
    <qb-ita-button
      type="submit"
      [label]="'GENESYS_CHAT.WIDGET.BUTTON.CANCEL' | translate"
      color="secondary"
      size="large"
      (click)="closeCustomChatWindow()"
    ></qb-ita-button>
    <qb-ita-button
      type="submit"
      [label]="'GENESYS_CHAT.WIDGET.BUTTON.OK' | translate"
      color="primary"
      size="large"
      (click)="submitName()"
    ></qb-ita-button>
  </div>
</div>
